import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './RequestsComponent.module.css';

const RequestsComponent = ({ vendorId }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRequests = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`/api/requests/${vendorId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          timeout: 10000,
        });
        setRequests(response.data.requests || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch requests');
      } finally {
        setLoading(false);
      }
    };

    if (vendorId) {
      fetchRequests();
    }
  }, [vendorId]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Vendor Requests</h2>
      
      {loading && (
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
        </div>
      )}

      {error && (
        <div className={styles.error}>
          {error}
        </div>
      )}

      {!loading && !error && requests.length === 0 && (
        <div className={styles.noData}>No requests found</div>
      )}

      {requests.length > 0 && (
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead className={styles.tableHeader}>
              <tr>
                <th className={styles.th}>Salesperson</th>
                <th className={styles.th}>Note</th>
                <th className={styles.th}>Type</th>
                <th className={styles.th}>Step</th>
                <th className={styles.th}>Status</th>
                <th className={styles.th}>Created At</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request._id} className={styles.tr}>
                  <td className={styles.td}>
                    {request.participantId?.name || 'N/A'}
                  </td>
                  <td className={styles.td}>{request.note}</td>
                  <td className={styles.td}>{request.type}</td>
                  <td className={styles.td}>{request.step}</td>
                  <td className={styles.td}>
                    <span
                      className={
                        request.isPending ? styles.statusPending : styles.statusActive
                      }
                    >
                      {request.isPending ? 'Pending' : 'Active'}
                    </span>
                  </td>
                  <td className={styles.td}>
                    {new Date(request.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RequestsComponent;